export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_14.95f1d80c.jpg";